import React, { useState , useEffect}  from 'react';
import { useStateContext } from '../../contexts/ContextProvider';
import {useRecepcionMutations} from '../../hooks';
import { SearchClienteEstado } from '../../components';
import { fetchUser } from '../../utils/fetchUser';
import { Toaster,toast } from 'react-hot-toast';
import {getDropoffs} from "../../services/dropoff";
import {getClientesRut} from "../../services/Clientes";

import ButtonToolBar from '../../components/ButtonToolBar';
import {formatDate} from '../../formatters/date';
import rutValidator from '../../utils/validateRut';

const initialState = {
empresa: null,
numeroRecepcion: 0,
idDropoff: null,
idCliente: '',
rutCliPro: '',
razonSocial:'',
cantidad: '',
descripcion:'',
fechaCreacion: Date.now()
};

const RegistroRecepcion = () => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [planesData, setPlanesData] = useState([]);
  const { addRecepcion } = useRecepcionMutations();

  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  const [buttonsTool, setButtonsTool] = useState([
    { name: 'cancel', label: 'Cancelar', disabled: false },
    { name: 'save', label: 'Guardar', disabled: false },
  ]);

  const userInfo = fetchUser();

  useEffect(() => {
    const fetchData = async () => {
      const miCliente = await getClientesRut(formData.rutCliPro);
      //console.log("LEI EL CLIENTE " + JSON.stringify(miCliente));
      if (miCliente.length > 0) {
        setFormData((prev) => ({
          ...prev,
          razonSocial: miCliente[0].razonSocial, idCliente: miCliente[0]._id,
        }));
      }
    };
    if(formData.rutCliPro !== '') {
      // Lee datos cliente usando API por rut
      fetchData();
    } else {
            setFormData((prev) => ({
          ...prev,
          razonSocial: '', idCliente: '',
        }));
    }
  }, [formData.rutCliPro]);

  useEffect(()=>{
    const fetchData = async () => {
      const misPlanes = await getDropoffs();
      setPlanesData(misPlanes);
      if(userInfo.rol === 'Drop-off'){
        setFormData((prev) => ({
            ...prev,
            idDropoff: userInfo.usuario ,
        }));
      }

    };
    fetchData();
  },[]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  
  const handleSubmit = async () =>{
    
    try {
        if( formData.idDropoff === '' || formData.idDropoff === null || formData.idDropoff === undefined )
          {
            toast.error('Debe seleccionar un Punto de Drop Off!');
            return;
          }
        if( formData.rutCliPro === '' && formData.rutCliPro === null && formData.rutCliPro === undefined )
          {
            toast.error('RUT Ingresado no es Válido!');
            return;
          }

        // Validaciones
        if( !rutValidator(formData.rutCliPro))
          {
            toast.error('RUT Ingresado no es Válido!');
            return;
          }

        if( formData.cantidad === '' || formData.cantidad === null || formData.cantidad === undefined )
          { 
            toast.error('Debe ingresar una Cantidad!');
            return;
          }
        
          if ( formData.cantidad < 0 || isNaN(formData.cantidad) ) {
          toast.error('Cantidad debe ser un número positivo!'); 
          return;
        }


          const datosSolicitud = {
            empresa: userInfo.empresa,
            numeroRecepcion: 0,
            idDropoff: formData.idDropoff,
            idCliente: formData.idCliente,
            cantidad: formData.cantidad,
            descripcion: formData.descripcion,
            fechaCreacion: Date.now(),
          };
          
         const daRecp = await addRecepcion.mutateAsync( datosSolicitud );
   
         setFormData((prev) => ({
          ...prev,
          numeroRecepcion: daRecp.numeroRecepcion,
        }));

         toast.success("Recepción de residuos realizada con N° " + daRecp.numeroRecepcion );
         setFormData(initialState);

    } catch (error) {
      console.log("Problemas al momento de Registrar Recepción de Residuos, contacte a soporte" + error);
      toast.error("Problemas al momento de Registrar Recepción de Residuos, contacte a soporte");
    }
  }
 
  const handleCancelar = async () =>{  
      setFormData(initialState);
  }

  const handleButtonToolBarClick = (buttonName) => {
    if (buttonName === 'save') {
      handleSubmit();
    } else if (buttonName === 'cancel') {
      handleCancelar();
    }
  };

  return (
    <form  onSubmit={handleSubmit} >
        <div className="m-2 md:m-10 mt-16 p-2 md:p-4 bg-gray-100 rounded-3xl">


        <div className="container mx-auto p-2 md:p-2">

        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-green-800 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                Recepción Residuos
              </p>
            </div>


          </div>

     <div className="bg-gray-200 p-6 rounded-lg shadow-lg mt-2">
        <div className="grid grid-cols-2 md:grid-cols-7 gap-4" >

            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Drop Off</label>
                <select className={inputClass} name="idDropoff" 
                value= {formData.idDropoff} 
                required
                onChange={handleChange}>
                  <option value=""></option>
                  {planesData?.map((item, index) => (
                    <option  key={item._id} value={item._id}>{item.nombrePunto}</option>
                  ))}  
                  </select> 
            </div> 

            <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Rut Cliente</label>
                  <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="rutCliPro"
                  value= {formData.rutCliPro}
                  onChange={handleChange}
                  />
                </div> 
            <div className="flex flex-col">
              <SearchClienteEstado estado='Activo' 
              onValorSeleccionadoChange={(cliSeleccionado) => {
                if (!cliSeleccionado) return;

                setFormData((prev) => ({
                  ...prev,
                    rutCliPro: cliSeleccionado.rutCliPro,
                    razonSocial: cliSeleccionado.razonSocial,
                }));

              }}
               />
            </div>
                <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Nombre</label>
                    <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="razonSocial"
                      value= {formData.razonSocial}
                      onChange={handleChange}
                      disabled 
                    />
                  </div> 
                </div>

            <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">N° Recepción</label>            
                <input
                className={inputClass}
                type="text"
                placeholder=""
                name="numeroRecepcion"
                value= {formData.numeroRecepcion}
                disabled
              />
            </div>
            <div className="col-span-2">
            <div className="flex flex-col items-start">      
              <label className="text-xs font-semibold mb-1">Fecha</label>            
              <input
                className={inputClass}
                type="text"
                placeholder=""
                name="fechaCreacion"
                value= {formatDate(formData.fechaCreacion)}
                disabled
              />
            </div>
            </div>

            </div>    
        </div>   

          <div className="mt-5 space-y-4">
              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4" >
                    <div className="col-span-4">
                      <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1">Observación</label>
                          <input
                              className={inputClass}
                              type="text"
                              placeholder=""
                              name="descripcion"
                              value= {formData.descripcion}
                              onChange={handleChange}
                            />
                      </div>  
                    </div> 
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Cantidad</label>
                      <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="cantidad"
                        value= {formData.cantidad}
                        onChange={handleChange}
                      />
                  </div> 
                </div>

                <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                  <div className="flex flex-col mt-4">
                    <ButtonToolBar buttons={buttonsTool} onButtonClick={handleButtonToolBarClick} />
                  </div>
                </div>

              </div>   
              <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} />         
          </div>

        </div>
      </div>
    </form>
  );
};

export default RegistroRecepcion;